import axios, { buildApi } from '@/libs/api.request';
let name = '/warehouse/tiktok/collect'

export const apis = buildApi({
  get: [name + '/index&list',],
})